import { cn } from '@/lib/cn'

interface FreshnessIndicatorProps {
  lastUpdated: string | null
}

export function FreshnessIndicator({ lastUpdated }: FreshnessIndicatorProps) {
  if (!lastUpdated) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-2.5 h-2.5 rounded-full bg-neutral-300" />
        <span className="text-xs text-neutral-500">Non confirmé</span>
      </div>
    )
  }

  const diffMinutes = Math.round((Date.now() - new Date(lastUpdated).getTime()) / 60000)
  let level: { color: string; label: string }

  if (diffMinutes <= 15) {
    level = { color: 'bg-success-500', label: 'Confirmé' }
  } else if (diffMinutes <= 30) {
    level = { color: 'bg-success-500', label: 'Récent' }
  } else if (diffMinutes <= 120) {
    level = { color: 'bg-warning-500', label: 'Ancien' }
  } else {
    level = { color: 'bg-error-500', label: 'Périmé' }
  }

  return (
    <div className="flex items-center gap-2">
      <div className={cn('w-2.5 h-2.5 rounded-full', level.color)} />
      <span className="text-xs text-neutral-500">
        {level.label} &middot; il y a {diffMinutes < 60 ? `${diffMinutes} min` : `${Math.round(diffMinutes / 60)}h`}
      </span>
    </div>
  )
}
